const _excluded = ["inputService", "label", "isLabelHidden", "optionList", "keyLookup", "itemRender", "multiSelect", "required", "disabled", "wrapperProps", "allowClear", "treatEmptyStringAsUndefined"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import isEqual from 'react-fast-compare';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Dropdown } from '../../Dropdown';
import { Label } from '../../Label';
import { Stack } from '../../Stack';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { SharedClearButton } from '../SharedClearButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DropDownControl(_ref) {
  let {
      inputService,
      label,
      isLabelHidden,
      optionList,
      keyLookup,
      itemRender,
      multiSelect = false,
      required = false,
      disabled = false,
      wrapperProps,
      allowClear,
      treatEmptyStringAsUndefined = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const {
    name,
    value,
    errorMessage,
    touched,
    send
  } = multiSelect ? useInput(inputService) : useInput(inputService);
  function getOptions() {
    if (!optionList) {
      return [];
    }
    return optionList.map(option => {
      return {
        key: keyLookup(option),
        text: itemRender(option)
      };
    });
  }
  function getSelectedKeys() {
    return value ? value.map(item => keyLookup(item)) : [];
  }
  function getValue(selected) {
    if (!selected || !optionList) {
      return multiSelect ? [] : treatEmptyStringAsUndefined ? undefined : '';
    }
    if (multiSelect) {
      const currentValues = Array.isArray(value) ? [...value] : [];
      const isAlreadySelected = currentValues.some(v => keyLookup(v) === selected.key);
      if (isAlreadySelected) {
        return currentValues.filter(v => keyLookup(v) !== selected.key);
      }
      const itemToAdd = optionList.find(v => keyLookup(v) === selected.key);
      return itemToAdd ? [...currentValues, itemToAdd] : currentValues;
    }
    const selectedValue = optionList.find(v => keyLookup(v) === selected.key);
    if (treatEmptyStringAsUndefined && selectedValue === '') {
      return undefined;
    }
    return selectedValue;
  }
  const selectOption = opt => {
    const updatedValue = getValue(opt);
    if (isEqual(updatedValue, value)) return;
    send({
      type: 'CHANGE',
      value: updatedValue
    });
    send({
      type: 'COMMIT'
    });
  };
  const handleOptionSpecialKeys = (event, opt) => {
    switch (event.key) {
      case 'Enter':
        event.stopPropagation();
        selectOption(opt);
        return event;
      default:
        return event;
    }
  };
  return /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({}, wrapperProps), {}, {
    children: [!isLabelHidden && /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: [/*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          disabled: disabled,
          children: [label !== null && label !== void 0 ? label : name, " ", required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      }), allowClear && !disabled && /*#__PURE__*/_jsx(Stack.Item, {
        align: "end",
        children: /*#__PURE__*/_jsx(SharedClearButton, {
          simple: allowClear === 'simple',
          send: send
        })
      })]
    }), /*#__PURE__*/_jsx(Dropdown, _objectSpread(_objectSpread({}, props), {}, {
      selectedKeys: multiSelect ? getSelectedKeys() : undefined,
      selectedKey: multiSelect ? undefined : value ? keyLookup(value) : '',
      multiSelect: multiSelect ? true : undefined,
      options: getOptions(),
      onChange: (_event, selected) => {
        selectOption(selected);
      },
      onBlur: () => {
        send({
          type: 'BLUR'
        });
      },
      onFocus: () => {
        send({
          type: 'FOCUS'
        });
      },
      required: label ? false : required,
      disabled: disabled,
      onOptionKeyDown: handleOptionSpecialKeys
    })), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  }));
}